import React from 'react';
import {useLocation} from 'react-router-dom';

import {Info} from '@pb/kit-component-info';
import Label from '@pb/kit-component-label';


const EDU_INFO = `This field shows the EDU attribute detected during the user's most recent login. It's read-only and helps the Support team identify potential login problems with unsupported EDU attributes.`;
const LABEL = 'EDU person affiliation';

const wrapContent = (content: React.ReactNode) => (
    <div style={{width: 300}}>
        <Label>
            <Info
                dropdownProps={{
                    style: {
                        width: '265px',
                    },
                }}
                type={{popover: EDU_INFO}}>
                {LABEL}
            </Info>
        </Label>
        {content}
    </div>
);

export const EduPersonAffiliation = ({edu}: {edu: string | undefined}) => {
    const {pathname} = useLocation();

    if (pathname.endsWith('/create-user')) {
        return null;
    }

    if (!edu) {
        return wrapContent(<span>--</span>);
    }

    return wrapContent(<span>{edu}</span>);
};
